module.exports = __webpack_public_path__ + "static/media/no-icon.30737c40.svg";